import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  total: 0,
};
const storeSlice = createSlice({
  name: 'store_management',
  initialState: initialState,
  reducers: {
    updateData: (state, action) => {
      state.data = action.payload.stores;
      state.total = action.payload.total;
    },
    addNewData: (state, action) => {
      const tmpData = [...state.data];
      tmpData.push(action.payload);
      state.data = tmpData;

      let total = state.total + 1;
      state.total = total;
    },
    deleteData: (state, action) => {
      const storeId = action.payload;
      const ids = state.data.map((item) => item._id);
      const idx = ids.indexOf(storeId);
      if (idx >= 0) {
        const tmpData = [...state.data];
        tmpData.splice(idx, 1);
        state.data = tmpData;

        const total = state.total - 1;
        state.total = total;
      }
    },
    updateStore: (state, action) => {
      const { storeId, payload } = action.payload;
      const ids = state.data.map((item) => item._id);
      const idx = ids.indexOf(storeId);
      if (idx >= 0) {
        const tmpData = [...state.data];
        tmpData[idx] = { ...tmpData[idx], ...payload };
        state.data = tmpData;
      }
    },
  },
});

export const storeAction = storeSlice.actions;

export default storeSlice.reducer;
